/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "eye-hidden-e3705243--sprite",
  "use": "eye-hidden-e3705243--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"eye-hidden-e3705243--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(-16.608 -764.836)\"><path d=\"M47.736,780.389l-.11-.11a17.229,17.229,0,0,0-6.86-4.5,17.726,17.726,0,0,0-7.67-.81l1.32,1.9c.22-.02.45-.02.68-.02a15.729,15.729,0,0,1,5.03.82,15.267,15.267,0,0,1,6.06,4l.11.11a.966.966,0,0,1,0,1.34,16.027,16.027,0,0,1-5.01,3.61l1.17,1.67a18.379,18.379,0,0,0,5.29-3.89A2.975,2.975,0,0,0,47.736,780.389Z\" fill=\"currentColor\" /><path d=\"M39.446,784.089a4.47,4.47,0,0,0,.31-1.64,4.669,4.669,0,0,0-4.67-4.67h-.03l1.98,2.84a2.739,2.739,0,0,1,.43.62Z\" fill=\"currentColor\" /><path d=\"M40.536,789.179a.031.031,0,0,0,.02-.01l-1.2-1.72c-.01,0-.01.01-.02,0l-1.09-1.58-1.16-1.66-2.96-4.25-1.16-1.66v-.01l-.82-1.16.01-.01-1.23-1.77h-.01l-3.55-5.09a.993.993,0,0,0-1.39-.24,1,1,0,0,0-.25,1.39l3.18,4.56a18.2,18.2,0,0,0-6.47,4.42,2.965,2.965,0,0,0,.01,4.12l.1.1a17.26,17.26,0,0,0,6.86,4.5,17.573,17.573,0,0,0,5.68.94,16.8,16.8,0,0,0,3.39-.34l2.81,4.03a1,1,0,0,0,1.39.25,1,1,0,0,0,.25-1.39Zm-7.87-7.82,2.6,3.74a1.086,1.086,0,0,1-.18.01,2.659,2.659,0,0,1-2.66-2.66A2.486,2.486,0,0,1,32.666,781.359Zm-2.62,5.86a15.3,15.3,0,0,1-6.06-4l-.1-.1a.969.969,0,0,1-.01-1.35,15.959,15.959,0,0,1,6.21-4.1l1.33,1.91a4.659,4.659,0,0,0,3.67,7.53,4.79,4.79,0,0,0,1.42-.22l.71,1.01A15.761,15.761,0,0,1,30.046,787.219Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
